import moment from "moment";
import { ONE_HOUR_IN_MILLISECONDS } from "../constants";

const getExpiryDateTimeFromNow = () =>
  moment().add(ONE_HOUR_IN_MILLISECONDS).toISOString();

export default getExpiryDateTimeFromNow;
